module.exports = __webpack_public_path__ + "media/images/backgrounds/how_to/lady-420ce5b92b3b3a31b5a1620066e823cf.svg";